(() => {
    const proofButtons = document.querySelectorAll('.proof__btn');

    proofButtons.forEach(button => {
        button.addEventListener('click', () => {
            const proofInner = button.closest('.proof__inner');

            if (!proofInner) return;

            proofInner.classList.toggle('is-active');

            const isActive = proofInner.classList.contains('is-active');
            button.setAttribute('aria-expanded', isActive);
        });
    });
})();